import { AccordionView } from "../../common/accordion/accordion.view";
import { useWaterSewageConfig } from "../../common/config/config.actions";
import { IAccordionData } from "../../common/interfaces/accordionData";
import { useWaterSewageQuery } from "../../Hooks";
import { useMunicipality } from "../../Contexts/MunicipalityKey";
import { BootstrapSpinner } from "../../common/spinners/bootstrapSpinner";
import { ISubscription, IWaterMeterModel } from "../../Types/WaterMeterTypes";
import WaterMeterPoint from "./WaterMeterPoint";
import Subscription from "./Subscription";

const WaterMeterPage = () => {
    const waterSewageConfig = useWaterSewageConfig();
    const municipalityConfig = useMunicipality();

    const {data: waterSewageItems, isLoading: isLoadingWaterSewageItems } = useWaterSewageQuery(municipalityConfig.name);

    const createAccordionData = () : IAccordionData[] => {
        let accordionData: { title: string; content: JSX.Element }[] = [];
        //console.log(waterSewageItems);
        
        waterSewageItems?.map(item => {
            accordionData.push({
                title: "Avtale: " + item.agreementId, // TODO: Replace with address and meterpoint placement
                content: ( <>{
                    item.waterMeterPointDataList && item.waterMeterPointDataList.length > 0 ?
                    item.waterMeterPointDataList.map(point => {
                    return (<WaterMeterPoint point={point.waterMeterPoint} ></WaterMeterPoint>)
                }) : ''}
                    <AccordionView showNarrow={true} content={createSubscriptionAccordionData(item.subscriptionList)}></AccordionView>
                    </>
                )
            })
        });

        return accordionData;
    }

    const createSubscriptionAccordionData = (subscriptions: ISubscription[])  => {
        let accordionData: { title: string; content: JSX.Element }[] = [];

        accordionData.push({
            title: "Gebyr",
            content: (<Subscription subscriptions={subscriptions} ></Subscription>)
        });

        return accordionData;
    }

    if (isLoadingWaterSewageItems)
        return <BootstrapSpinner title="Henter vannmålerdataene dine" />;
    else {
        return (
        <>
            <div className="container my-water-meters">
            <h1>Vann og avløp</h1>
            <p>{waterSewageConfig?.ingressText}</p>
            {waterSewageConfig?.hideService ? (
                "Tjenesten er dessverre ikke tilgjengelig."
            ) : (
                <>
                {waterSewageConfig?.alertText &&
                    waterSewageConfig?.alertText !== "" && (
                    <div className="infoBoxLanding">
                        <p>{waterSewageConfig?.alertText}</p>
                    </div>
                    )}
                <p>{waterSewageConfig?.ingressText}</p>
                <AccordionView
                    content={createAccordionData()}
                    hideBorder={true}
                />
                </>
            )}
            </div>
        </>
        );
    }
}

export default WaterMeterPage;